import { IoLogoWhatsapp } from 'react-icons/io'
import { BsTelegram } from 'react-icons/bs'
import { RiInstagramFill } from 'react-icons/ri'
import { FaFacebook, FaFacebookMessenger } from 'react-icons/fa6'
import { MdEmail, MdLocalPhone } from 'react-icons/md'
import logo from '../assets/images/logo.avif'
import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation()
  return (
    <footer className='bg-black p-4 sm:py-12'>
      <div className='w-[96%] lg:w-5/6 mx-auto'>
        <div className='flex items-center gap-1 -ml-4 lg:-ml-6'>
          <img
            src={logo}
            alt='logo'
            className='w-20 sm:w-32 h-20 sm:h-32'
          />
          <p className='sm:text-5xl text-xl font-semibold sm:mb-2 gold'>
            {t('footer.title')}
          </p>
        </div>
        <p className='text-sm font-bold goldA uppercase pt-2 w-1/2'>
          {t('footer.content')}
        </p>
        <div className='py-12 border-b-[1px] border-yellow-100'>
          <p className='gold mb-2'>Follow us</p>
          <nav className='flex items-center gap-6 text-[#ffecb3]'>
            <a
              href={'http://wa.me/+79685756630'}
              target='_blank'
              rel='noreferrer'
            >
              <IoLogoWhatsapp
                size={38}
                className='hover:text-[#c7b07f]'
              />
            </a>
            <a
              href='/'
              target='_blank'
              rel='noreferrer'
            >
              <BsTelegram
                size={32}
                className='hover:text-[#c7b07f]'
              />
            </a>
            <a
              href='https://www.instagram.com/hygge_olga?igsh=MTlpNXNhMW1idnZldQ=='
              target='_blank'
              rel='noreferrer'
            >
              <RiInstagramFill
                size={38}
                className='hover:text-[#c7b07f]'
              />
            </a>
            <a
              href='/'
              target='_blank'
              rel='noreferrer'
            >
              <FaFacebook
                size={32}
                className='hover:text-[#c7b07f]'
              />
            </a>
            <a
              href='/'
              target='_blank'
              rel='noreferrer'
            >
              <FaFacebookMessenger
                size={32}
                className='hover:text-[#c7b07f]'
              />
            </a>
          </nav>
        </div>
        <div className='py-8'>
          <div className='flex items-center gap-2 text-white'>
            <MdLocalPhone className='text-yellow-100' />
            <p className='gold'>+79685756630</p>
          </div>
          <div className='flex items-center gap-2 gold'>
            <MdEmail />
            <p className='goldA text-xs'>samolga89@gmail.com</p>
          </div>
        </div>
        <p className='text-[10px] gold'> Working Since 2005</p>
      </div>
    </footer>
  )
}
